import {
  Box,
  IconButton,
  Paper,
  Switch,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Header from "../../components/Header";
import { tokens } from "../../theme";
import { useLayoutEffect, useMemo, useState } from "react";
import axios from "axios";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import {
  Email,
  Google,
  Preview,
  Print,
  ReportGmailerrorred,
  WhatsApp,
} from "@mui/icons-material";
import ReportDialog from "../reports/ReportDialog";
import LoadingBackDrop from "../global/LoadingBackDrop";
import { getPayload } from "../../services/api";
import PDFViewerDialog from "../jasperReports/PDFViewerDialog";
import PDFSendWhatsAppDialog from "../jasperReports/PDFSendWhatsAppDialog";

const JobAuthorizeCommon = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [loading, setLoading] = useState(false);
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const [completedJobs, setCompletedJobs] = useState([]);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState();
  const [openReportDialog, setOpenReportDialog] = useState(false);
  const [selectedRequestId, setSelectedRequestId] = useState({});
  const [openReportPreviewDialog, setOpenReportPreviewDialog] = useState(false);
  const [openPDFPreviewDialog, setOpenPDFPreviewDialog] = useState(false);
  const [openWhatsAppPreviewDialog, setOpenWhatsAppPreviewDialog] =
    useState(false);
  const [data, setData] = useState([]);
  const [letterHead, setLetterHead] = useState(false);
  const [sendReportType, setSendReportType] = useState("");
  const handleCloseToaste = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const loggedUser = JSON.parse(localStorage.getItem("user"));
  useLayoutEffect(() => {
    loadBasicData();
  }, [message]);
  const label = { inputProps: { "aria-label": "Size switch demo" } };
  const loadBasicData = async () => {
    setLoading(true);

    await getPayload
      .getPayloadData("/labReq/engineer/all/assignedJobsEngineer")
      .then(function (response) {
        // console.log("this is response data -------------", response.data);
        setCompletedJobs(response.data.pendingRequests);
        setData(response.data.allReports);
        // console.log("tabledata", response.data.tableData);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const sendEmailToCustomer = async (testData) => {
    setLoading(true);
    await axios
      .put(DATA_SAVE_URL + "/api/v1/labPayment/sendEmail" + testData.id)
      .then(function (response) {
        console.log("this is response data -------------", response.data);

        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const handleSendEmail = async (event, selectedData) => {
    setLoading(true);
    console.log("checked status", event.target.checked, "id ", selectedData);
    await axios
      .put(
        DATA_SAVE_URL + "/api/v1/labReq/all/sendEmailStatus" + selectedData.id,
        null,
        {
          params: {
            emailSent: event.target.checked,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then(function (response) {
        console.log("response,", response.data);
        setCompletedJobs(response.data.pendingRequests);
        setData(response.data.allReports);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const handleCloseReport = () => {
    setOpenReportDialog(false);
  };
  const handleOpenReportPreview = () => {
    setOpenReportPreviewDialog(true);
  };
  const handleCloseReportPreview = () => {
    setOpenReportPreviewDialog(false);
  };

  const handleOpenPDFPreview = () => {
    setOpenPDFPreviewDialog(true);
  };
  const handleClosePDFPreview = () => {
    setOpenPDFPreviewDialog(false);
  };

  const handleCloseWhatsAppPreview = () => {
    setOpenWhatsAppPreviewDialog(false);
  };

  const handleOpenWhatsAppPreview = () => {
    setOpenWhatsAppPreviewDialog(true);
  };

  //should be memoized or stable
  const columns = useMemo(
    () => [
      {
        accessorFn: (row) =>
          `QC/${row.reportType}/${row.labRequest.year}/${String(
            row.id
          ).padStart(4, "0")}`,
        //accessorKey: "institute.instituteName", //access nested data with dot notation
        header: "Report No",
        size: 100,
      },

      {
        accessorKey: "date",
        header: "Report Date",
        size: 80,
      },
      {
        accessorFn: (row) =>
          `${row.labRequest.year}/${String(
            row.labRequest.autoIdByYear
          ).padStart(3, "0")}`,
        //accessorKey: "institute.instituteName", //access nested data with dot notation
        header: "Job No",
        size: 100,
      },
      {
        accessorKey: "labRequest.regDate",
        header: "Job Date",
        size: 150,
      },

      {
        accessorKey: "finalizeDate",
        header: "Authorized Date",
        size: 150,
      },

      {
        accessorKey: "barcode",
        header: "Barcode",
        size: 150,
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data,

    enableRowActions: true,
    positionActionsColumn: "last",

    initialState: {
      density: "compact",
      pagination: { pageSize: 25, pageIndex: 0 },
    },

    muiPaginationProps: {
      rowsPerPageOptions: [25, 50, 100, 150, 200],
      showFirstButton: true,
      showLastButton: true,
    },

    muiTableBodyRowProps: ({ row }) => ({
      //conditionally style expanded rows

      sx: {
        padding: "10px",
        backgroundColor: row.original.labRequestTests.emailSent
          ? colors.greenAccent[800]
          : "#ffefaeff",
      },
    }),

    renderRowActions: ({ closeMenu, row }) => [
      <Tooltip title="View Report">
        <IconButton
          onClick={() => {
            setLetterHead(true);
            setSelectedRequestId(row.original);
            handleOpenPDFPreview();
          }}
          aria-label="View Report"
          size="medium"
        >
          <Preview fontSize="inherit" color="warning" />
        </IconButton>
      </Tooltip>,
      <Tooltip title="Print Without Letter Head">
        <IconButton
          onClick={() => {
            setLetterHead(false);
            setSelectedRequestId(row.original);
            handleOpenPDFPreview();
          }}
          aria-label="Letter Head"
          size="medium"
        >
          <Print fontSize="inherit" color="info" />
        </IconButton>
      </Tooltip>,
      <Tooltip title="Send Email">
        <IconButton
          onClick={() => {
            setSendReportType("EMAIL");
            setSelectedRequestId(row.original);
            handleOpenWhatsAppPreview();
          }}
          aria-label="Send Email"
          size="medium"
        >
          <Google fontSize="inherit" color="error" />
        </IconButton>
      </Tooltip>,
      <Tooltip title="Report send status">
        <Switch
          onChange={(e) => {
            handleSendEmail(e, row.original);
          }}
          // {...label}
          checked={row.original.labRequestTests.emailSent ? true : false}
          size="small"
        />
      </Tooltip>,
      <Tooltip title="Send WhatsApp Link">
        <IconButton
          onClick={() => {
            setSendReportType("WHATSAPP");
            setSelectedRequestId(row.original);
            handleOpenWhatsAppPreview();
          }}
          aria-label="Send WhatsApp Link"
          size="medium"
        >
          <WhatsApp fontSize="inherit" color="success" />
        </IconButton>
      </Tooltip>,
    ],
  });
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        textAlign: "center",
      }}
    >
      {" "}
      {loading ? <LoadingBackDrop openBackDrop={loading} /> : ""}
      <Box
        sx={{
          width: "100%",
          justifyContent: "center",
          alignContent: "center",
          justifyItems: "center",
          justifyItems: "center",
          textAlign: "center",
        }}
      >
        <Paper
          sx={{
            padding: "15px",
            borderRadius: "8px",
            width: "95%",
            marginTop: "15px",
          }}
          elevation={3}
        >
          <Header title="Authorized Reports" subtitle="Save / Update" />
          <Box display="flex" margin={1}></Box>
          <MaterialReactTable table={table} />
        </Paper>
      </Box>
      <ReportDialog
        colors={colors}
        isNonMobile={isNonMobile}
        handleOpenReportPreview={handleOpenReportPreview}
        handleCloseReportPreview={handleCloseReportPreview}
        open={openReportPreviewDialog}
        data={selectedRequestId}
        letterHead={letterHead}
      />
      <PDFViewerDialog
        reportNo={`QC_${selectedRequestId?.reportType}_${
          selectedRequestId?.labRequest?.year
        }_${String(selectedRequestId?.id).padStart(4, "0")}`}
        labRequestId={selectedRequestId?.barcode}
        open={openPDFPreviewDialog}
        handleCloseReportPreview={handleClosePDFPreview}
        reportType={"REPORT"}
        letterHead={letterHead}
      />
      <PDFSendWhatsAppDialog
        reportNo={`QC_${selectedRequestId?.reportType}_${
          selectedRequestId?.labRequest?.year
        }_${String(selectedRequestId?.id).padStart(4, "0")}`}
        jobNo={`JOB/${selectedRequestId?.labRequest?.year}/${String(
          selectedRequestId?.labRequest?.id
        ).padStart(4, "0")}`}
        labRequestId={selectedRequestId?.barcode}
        open={openWhatsAppPreviewDialog}
        handleCloseReportPreview={handleCloseWhatsAppPreview}
        reportType={selectedRequestId.reportType}
        loggedUserData={`${loggedUser.firstName} ${loggedUser.lastName}`}
        contactNo={selectedRequestId?.institute?.contactNo}
        emailAddress={selectedRequestId?.institute?.email}
        sendReportType={sendReportType}
      />
    </Box>
  );
};

export default JobAuthorizeCommon;
